import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "planPurchase",
    serviceName: "auth",
    query: gql`
      query planPurchase($ids: [String]) {
        planPurchase(ids: $ids) {
          data {
            plan {
              title
              related_to
            }
            amount
            lab_quantity
            unit_quantity
            validity_months
            doctor_quantity
            details
          }
        }
      }
    `,
  },
  update: {
    name: "updatePlanPurchase",
    serviceName: "auth",
    query: gql`
      mutation updatePlanPurchase(
        $ids: [String]!
        $payment_status_id: String
        $validity_months: String
        $expire_at: String
        $lab_quantity: String
        $unit_quantity: String
        $doctor_quantity: String
        $details: String
      ) {
        updatePlanPurchase(
          ids: $ids
          payment_status_id: $payment_status_id
          validity_months: $validity_months
          expire_at: $expire_time
          lab_quantity: $lab_quantity
          unit_quantity: $unit_quantity
          doctor_quantity: $doctor_quantity
          details: $details
        ) {
          messages
          influenced_count
        }
      }
    `,
  },
};

export default schema;
